/**
 * One source of truth for every GET call.
 * All helpers attach params via axios' `params` option, so the server
 * receives a query‑string exactly like it did in PHP.
 */

import axios from 'axios';
import { apis } from '../Auth/Api';

/* ——— standard helpers (unchanged) ——— */
export const getWeather                = () => axios.get(`${apis.baseUrl}${apis.getWeather}`);
export const getAllDepartment          = () => axios.get(`${apis.baseUrl}${apis.getAllDepartment}`);
export const getAllDepartmentById      = id => axios.get(`${apis.baseUrl}${apis.getAllDepartment}${id}`);
export const getAllFaculty             = () => axios.get(`${apis.baseUrl}${apis.getAllFaculty}`);
export const getAllFacultyById         = id => axios.get(`${apis.baseUrl}${apis.getAllFaculty}${id}`);
export const getAllOMR                 = () => axios.get(`${apis.baseUrl}${apis.getAllOMR}`);
export const getAllOMRById             = id => axios.get(`${apis.baseUrl}${apis.getAllOMR}${id}`);
export const getAllSyllabus            = () => axios.get(`${apis.baseUrl}${apis.getAllSyllabus}`);
export const getAllExamRelatedInfo     = () => axios.get(`${apis.baseUrl}${apis.getAllExamRelatedInfo}`);
export const getAllExamSchedule        = () => axios.get(`${apis.baseUrl}${apis.getAllExamSchedule}`);
export const getAllRevisedExamSchedule = () => axios.get(`${apis.baseUrl}${apis.getAllRevisedExamSchedule}`);
export const getAllCodeBooksandDownloads = () => axios.get(`${apis.baseUrl}${apis.getAllCodeBooksandDownloads}`);
export const getAllCareerInfo          = () => axios.get(`${apis.baseUrl}${apis.getAllCareerInfo}`);
export const getAllTendersInfo         = () => axios.get(`${apis.baseUrl}${apis.getAllTendersInfo}`);
export const getAllSportsCalendar      = () => axios.get(`${apis.baseUrl}${apis.getAllSportsCalendar}`);
export const getAllHomeData            = () => axios.get(`${apis.baseUrl}${apis.getHomeData}`);

/* ——— NEWS SEARCH (single endpoint just like PHP) ——— */
export const getAllSearchNewsData = (params = {}) =>
  axios.get(`${apis.baseUrl}${apis.getAllSearchNewsData}`, { params });

/* legacy alias kept so nothing else breaks */
export const getAllSearchNewsByCategoryData = (params = {}) =>
  axios.get(`${apis.baseUrl}${apis.getAllSearchNewsData}`, { params });
